export default "\r\n<div id=\"content\">\r\n  <button class=\"menuButton\" mat-flat-button (click)=\"newPassword()\">Change Password</button> \r\n</div>\r\n"